import { useState, useEffect } from 'react';
import { List, Datagrid, TextField, useRecordContext, EmailField, TextInput, ReferenceInput, SelectInput, ReferenceField, Edit, SimpleForm, useGetList, useDataProvider, Create, required, DateTimeInput, DateField, FunctionField } from 'react-admin';
import Typography from '@mui/material/Typography';
import CircularProgress from '@mui/material/CircularProgress';
import { roundPrice, timestampToStrDate } from '../utils/utils';

import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';

export const SubscriptionList = (props) => {
    var record = useRecordContext();
    const dataProvider = useDataProvider();
    const [subscriptions, setSubscriptions] = useState();
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState();

    useEffect(() => {

        if(record != undefined){
            var id = record.clientId;
            if(record.hasOwnProperty("clientId"))
                id = record.clientId;
            dataProvider.getList('users/'+id+"/subscriptions", {
                pagination: { page: 1, perPage: 999999 },
                sort: { field: 'id', order: 'ASC' },
                filter: {  },
            })
            .then(({ data }) => {
                setSubscriptions(data);
                setLoading(false);
            })
            .catch(error => {
                setError(error);
                setLoading(false);
            });
        }
            
    }, [record]);

    if (loading) return <CircularProgress style={{margin: "auto"}} color="inherit" />;
    if (error) return <Typography variant="h6" color="red">Erreur lors du chargement des offres de fidélité.</Typography>;
    if (!subscriptions) return null;

    if(subscriptions.length == 0) return <Typography variant="h6" color="inherit">Aucune offre de fidélité enregistrée.</Typography>;

    return (
        <div style={{width: "100%"}}>
            <TableContainer component={Paper}>
                <Table sx={{ minWidth: 650 }} aria-label="simple table">
                    <TableHead>
                    <TableRow>
                        <TableCell>ID</TableCell>
                        <TableCell>ID de la transactionId</TableCell>
                        <TableCell>Montant payé</TableCell>
                        <TableCell>Montant reçu</TableCell>
                    </TableRow>
                    </TableHead>
                    <TableBody>
                    {subscriptions.map((subscription) => (
                        <TableRow
                        key={subscription.id}
                        sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                        >
                            <TableCell component="th" scope="row">
                                {subscription.id}
                            </TableCell>
                            <TableCell>{subscription.transactionId}</TableCell>
                            <TableCell>{roundPrice(subscription.amount/100)}€</TableCell>
                            <TableCell>{roundPrice(subscription.amountObtained/100)}€</TableCell>
                        </TableRow>
                    ))}
                    </TableBody>
                </Table>
            </TableContainer>
        </div>
    )
};